<script lang="ts">
  import {
    AlertCircleIcon,
    BriefCaseIcon,
    RefreshIcon,
    CheckedVerifiedIcon,
    CheckCircle,
    Bin,
    Documents,
    DoubleCheck,
    DollarCircleIcon,
    ClockRefresh,
    Email,
    MailOpen,
    Phone,
    PhoneIn,
    PhoneOut,
    PhoneIncomingIcon,
    PhoneMissedIcon,
    CalendarPlus,
    Message,
    UserPlusIcon,
    MailIcon,
    ChevronLeftIcon,
    Confetti,
    NoConnectionIcon,
    QuestionMarkCircle,
  } from '../icons';
  export let size: 'xlarge' | 'large' | 'medium' | 'small' = 'xlarge';
  export let type: 'success' | 'primary' | 'warning' | 'error' | 'gray' =
    'success';
  export let icon = 'alert-circle';
  export let outlined = false;
  export let theme: 'modern' | '' = '';

  const icons = {
    'alert-circle': AlertCircleIcon,
    'brief-case': BriefCaseIcon,
    refresh: RefreshIcon,
    'check-circle': CheckCircle,
    'checked-verified': CheckedVerifiedIcon,
    bin: Bin,
    documents: Documents,
    'chevron-left': ChevronLeftIcon,
    'double-check': DoubleCheck,
    'dollar-circle': DollarCircleIcon,
    'clock-refresh': ClockRefresh,
    phone: Phone,
    phoneIn: PhoneIn,
    phoneOut: PhoneOut,
    email: Email,
    'phone-incoming': PhoneIncomingIcon,
    'phone-missed': PhoneMissedIcon,
    'mail-open': MailOpen,
    'calendar-plus': CalendarPlus,
    message: Message,
    userPlus: UserPlusIcon,
    mail: MailIcon,
    confetti: Confetti,
    noConnection: NoConnectionIcon,
    questionMarkCircle: QuestionMarkCircle,
  };
</script>

<i class="featuredIcon {type} {size} {theme}" class:outlined>
  <svelte:component this={icons[icon]} />
</i>

<style lang="scss">
  .featuredIcon {
    display: flex;
    padding: 14px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    &.success {
      background: var(--color-success-light, #ecfdf3);
      color: var(--color-success);
    }
    &.primary {
      background: var(--color-primary-light, #f5fbff);
      color: var(--color-primary);
    }
    &.warning {
      background: var(--color-alert-light, #fef0c7);
      color: var(--color-alert);
    }
    &.error {
      background: var(--color-error-light, #fff0f0);
      color: var(--color-error);
    }
    &.gray {
      background: var(--color-background-light, #f9fafa);
      color: var(--color-neutralGreyDark);
    }

    &.outlined {
      background: #fff;
      &.success {
        color: var(--color-success);
        box-shadow: inset 0px 0px 0px 10px var(--color-success-light, #ecfdf3);
      }
      &.primary {
        box-shadow: inset 0px 0px 0px 10px var(--color-primary-light, #f5fbff);
        color: var(--color-primary);
      }
      &.warning {
        box-shadow: inset 0px 0px 0px 10px var(--color-alert-light, #fef0c7);
        color: var(--color-alert);
      }
      &.error {
        box-shadow: inset 0px 0px 0px 10px var(--color-error-light, #fff0f0);
        color: var(--color-error);
      }
      &.gray {
        box-shadow: inset 0px 0px 0px 10px
          var(--color-background-light, #f9fafa);
        color: var(--color-neutralGreyDark);
      }
    }

    &.xlarge {
      width: 56px;
      height: 56px;
      :global(svg) {
        width: 28px;
        height: 28px;
      }
    }

    &.large {
      width: 40px;
      height: 40px;
      padding: 10px;
      :global(svg) {
        width: 20px;
        height: 20px;
      }
    }

    &.medium {
      width: var(--spacing-medium);
      height: var(--spacing-medium);
      padding: var(--spacing-nano);
      :global(svg) {
        width: var(--spacing-mini);
        height: var(--spacing-mini);
      }
    }

    &.small {
      width: 24px;
      height: 24px;
      padding: 6px;
      :global(svg) {
        width: 12px;
        height: 12px;
      }
    }

    &.modern {
      border: 1px solid var(--color-neutralExtraLight);
    }
  }
</style>
